import altvoc_green from "assets/phase3/names/altvoc_green.png";
import altvoc_red from "assets/phase3/names/altvoc_red.png";
import altvoc_yellow from "assets/phase3/names/altvoc_yellow.png";
import altvoc_off from "assets/phase3/names/altvoc_off.png";

import inst_green from "assets/phase3/names/inst_green.png";
import inst_red from "assets/phase3/names/inst_red.png";
import inst_yellow from "assets/phase3/names/inst_yellow.png";
import inst_off from "assets/phase3/names/inst_off.png";

import base_green from "assets/phase3/names/base_green.png";
import base_red from "assets/phase3/names/base_red.png";
import base_yellow from "assets/phase3/names/base_yellow.png";
import base_off from "assets/phase3/names/base_off.png";

import drum_green from "assets/phase3/names/drum_green.png";
import drum_red from "assets/phase3/names/drum_red.png";
import drum_yellow from "assets/phase3/names/drum_yellow.png";
import drum_off from "assets/phase3/names/drum_off.png";

import vocmel_green from "assets/phase3/names/vocmel_green.png";
import vocmel_red from "assets/phase3/names/vocmel_red.png";
import vocmel_yellow from "assets/phase3/names/vocmel_yellow.png";
import vocmel_off from "assets/phase3/names/vocmel_off.png";

import record_green from "assets/phase3/names/record_green.png";
import record_red from "assets/phase3/names/record_red.png";
import record_yellow from "assets/phase3/names/record_yellow.png";
import record_off from "assets/phase3/names/record_off.png";


const namesAssets = {
  altvoc: {
    green: altvoc_green,
    red: altvoc_red,
    yellow: altvoc_yellow,
    off: altvoc_off,
  },
  inst: {
    green: inst_green,
    red: inst_red,
    yellow: inst_yellow,
    off: inst_off,
  },
  drum: {
    green: drum_green,
    red: drum_red,
    yellow: drum_yellow,
    off: drum_off,
  },
  vocmel: {
    green: vocmel_green,
    red: vocmel_red,
    yellow: vocmel_yellow,
    off: vocmel_off,
  },
  base:{
    green: base_green,
    red: base_red,
    yellow: base_yellow,
    off: base_off,
  },
  record:{
    green: record_green,
    red: record_red,
    yellow: record_yellow,
    off: record_off,
  }
};

const getNamesAsset = (name, color) => {
    if(!namesAssets[name]) return null;
    if(!namesAssets[name][color]) return null;
    return namesAssets[name][color];
  };

export default getNamesAsset;
